export default {
    "MEDICINE_CAVE": [
         "0x5069"
    ],
    "HEART_CLIFF": [
         "0x4dd7"
    ],
    "P3": [
         "0x1252d"
    ],
    "EX_LIFE_SWAMP_1": [
         "0x4e57"
    ],
    "EX_LIFE_BEACH": [
         "0x4fd3"
    ],
    "TROPHY_CAVE": [
         "0x4dea"
    ],
    "MAGIC_CAVE": [
         "0x502a"
    ],
    "FOREST_50P": [
         "0x4e1b"
    ],
    "CAVE_200P": [
         "0x4fe2"
    ],
    "P2": [
         "0x10e9a"
    ],
    "HEART_CAVE": [
         "0x4ff5"
    ],
    "P1": [
         "0x10e91"
    ],
    "FOREST_100P": [
         "0x4e3a"
    ],
    "FIRE_TOWN_FOREST_500P_BAG": [
         "0x8dbe"
    ],
    "DEATH_VALLEY_500P_BAG": [
         "0x9039"
    ],
    "DAZZLE_LIFE": [
         "0x8f93"
    ],
    "SPELL_TOWN": [
         "0xdb8c",
         "0xdb95"
    ],
    "P6_500P_BAG": [
         "0x8e2d"
    ],
    "P5": [
         "0x10ea3"
    ],
    "FIRE_TOWN_CAVE_500P_BAG": [
         "0x8ecc"
    ],
    "THUNDER_TOWN_CAVE_500P_BAG": [
         "0x8fb3"
    ],
    "P5_HEART": [
         "0x8faa"
    ],
    "THUNDER_TOWN_SWAMP_LIFE": [
         "0x8e02"
    ],
    "P6": [
         "0x12774"
    ],
    "DM_MAGIC": [
         "0x65c3"
    ],
    "HAMMER_CAVE": [
         "0x6512"
    ],
    "P4": [
         "0x12538"
    ],
    "MAZE_ISLAND_MAGIC": [
         "0xa5a8"
    ],
    "MAZE_ISLAND_CHILD": [
         "0xa58b"
    ],
    "P6_HEART": [
         "0x9011"
    ],
    "P5_500P_BAG": [
         "0x8ddd"
    ]
}